import {applyResultCart} from "@Common/logic/checkout/common/apply-result-cart";
import {setNestedValue}  from "@Common/utils/arr-path";
import {chain}           from "@Common/utils/fs";

export const createSetCredits = ({collectCredits, cartAttr}) => (set, {apis}) => ({
    action: async (cart) => {
        return {
            change: applyResultCart(await apis.next.cart.updateCart(chain(
                {cartId: cart.cartId},
                (_) => set ? (
                    setNestedValue(_, ["credits", cartAttr], collectCredits(cart, set))
                ) : (
                    setNestedValue(_, ["removeCredits", cartAttr], cart.appliedCredits[cartAttr])
                ),
            ))),
        };
    },
});

